module.exports = __webpack_public_path__ + "static/media/discount.46e3a6cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/TradeCryptoResources/discount.svg
// module id = 167
// module chunks = 0